import React from "react";
import ButtonTertiary from "../ui/buttons/tertiary";
import LayoutSection from "../../layouts/layoutSection";
import TextSection from "../ui/typographic/textSection";
import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";

export default function AllPosts({ data, button, page }) {

  const posts = data.allWpPost.nodes
  const meta = data.allWpPost.edges

  return (

    <LayoutSection
      full
    >
      <div className="grid grid-cols-4 gap-1 h-full min-h-screen masonry">
        <div className="col-span-4 md:col-span-2 orange-bckd flex justify-center items-center text-white py-8">
          <div className="w-3/4 mx-auto flex justify-center items-center gap-8">
            <div className="flex-1">
              <Link to={posts[0].uri}>
                <h3 className="text-lg mb-2 after">{posts[0].title}</h3>
                <p className=" text-sm text-white">{meta[0].node.seo.metaDesc}</p>
              </Link>
            </div>
            <div className="flex-0 h-40 w-40 rounded-full hidden md:block relative">
              <GatsbyImage
                image={posts[0].featuredImage.node.gatsbyImage}
                className=' rounded-full absolute h-full'
                alt={posts[0].title}
              />
            </div>
          </div>
        </div>

        <div className="col-span-4 md:col-span-1 violet-bckd flex justify-center items-center text-white py-8">
          <div className="w-3/4 mx-auto text-center">
            <Link to={posts[1].uri}>
              <h3 className="text-lg mb-2 after-center">{posts[1].title}</h3>
              <p className=" text-sm text-white">{meta[1].node.seo.metaDesc}</p>
            </Link>
          </div>
        </div>

        <div className="col-span-4 md:col-span-1 md:row-span-2 flex justify-center items-center bleu-bckd py-8">
          <div className="w-3/4 mx-auto flex flex-col gap-8 text-center text-white">
            <div className="flex-1">
              <Link to={posts[2].uri}>
                <h3 className="text-lg mb-2 after-center">{posts[2].title}</h3>
              </Link>
            </div>
            <div className="h-40 w-40 rounded-full flex-0 mx-auto hidden relative md:block">
              <GatsbyImage
                image={posts[2].featuredImage.node.gatsbyImage}
                className=' rounded-full absolute h-full w-full left-0'
                alt={posts[2].title}
              />
            </div>
          </div>
        </div>

        <div className=" col-span-4 md:col-span-1 md:row-span-2 flex justify-center items-center light-bleu-bckd py-8">
          <div className="w-3/4 mx-auto flex flex-col gap-8 text-center bleu">
            <div className="flex-1">
              <Link to={posts[3].uri}>
                <h3 className="text-lg mb-4 after-center">{posts[3].title}</h3>
              </Link>
            </div>
            <div className="h-40 w-40 rounded-full flex-0 mx-auto hidden relative md:block">
              <GatsbyImage
                image={posts[3].featuredImage.node.gatsbyImage}
                className=' rounded-full absolute h-full w-full left-0'
                alt={posts[3].title}
              />
            </div>
          </div>
        </div>

        <div className="col-span-4 row-start-1 md:row-start-auto  md:col-span-2 flex justify-center items-center py-8 bleu bg-slate-100">
          <div className="flex gap-4 w-11/12">
            <div className=" flex-1/2">

              <StaticImage alt="academie télécom" src="../../../../static/imgs/academie.svg" />
            </div>
            <div className="flex-1/2 text-left">
              {
                !page ?
                  <h2 className="text-5xl mb-2">Napsis Académie</h2>
                  : <h1 className="text-5xl mb-2">Napsis Académie</h1>
              }
              <TextSection
                content='Les télécoms peuvent être difficiles à aborder. Nous vous proposons une étude des technologies clés'
                size="s"
                extra="mb-4"
              />
              {
                button ?
                  <Link to="/academie">
                    <ButtonTertiary cta='retrouvez nos articles' color='orange' />
                  </Link>
                  : ''
              }
            </div>
          </div>
        </div>

        <div className="col-span-4 md:col-span-1 md:col-start-2 flex justify-center items-center deep-orange-bckd py-8">
          <div className="w-3/4 mx-auto text-center text-white">
            <Link to={posts[4].uri}>
              <h3 className="text-lg mb-2 after-center">{posts[4].title}</h3>
              <p className=" text-sm text-white">{meta[4].node.seo.metaDesc}</p>
            </Link>
          </div>
        </div>
        <div className="col-span-4 md:col-span-1 md:col-start-3 flex justify-center items-center x-light-violet-bckd py-8">
          <div className="w-3/4 mx-auto text-center bleu">
            <Link to={posts[5].uri}>
              <h3 className="text-lg mb-2 after-center">{posts[5].title}</h3>
              <p className=" text-sm bleu">{meta[5].node.seo.metaDesc}</p>
            </Link>
          </div>
        </div>

        <div className="col-span-4 md:col-span-1 md:col-start-4 flex justify-center items-center light-bleu-bckd py-8">
          <div className="w-3/4 mx-auto text-center bleu">
            <Link to={posts[6].uri}>
              <h3 className="text-lg mb-4 after-center">{posts[6].title}</h3>
              <p className=" text-sm">{meta[6].node.seo.metaDesc}</p>
            </Link>
          </div>
        </div>
      </div>
    </LayoutSection>
  )
}

